'use client';
import { client } from '@/sanity/lib/client';
import { FOOTER_QUERY } from '@/sanity/queries/footer';
import { useEffect, useState } from 'react';
import type { FooterData } from '../interfaces';

export const useFooter = () => {
  const [footerData, setFooterData] = useState<FooterData | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        setLoading(true);
        const query = FOOTER_QUERY;

        const data = await client.fetch(query);
        setFooterData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch footer data');
      } finally {
        setLoading(false);
      }
    };

    fetchFooter();
  }, []);

  return { footerData, loading, error };
};
